import { HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CaseUploadService } from 'src/app/case-upload.service';
import { ClientContractPackageService } from 'src/app/client-contract-package.service';
import { ClientContractProfileService } from 'src/app/client-contract-profile.service';
import { ComponentDataService } from 'src/app/component-data.service';
import { ComponentService } from 'src/app/component.service';
import { PersonalDetailsDataService } from 'src/app/personal-details-data.service';
import { SaveConfirmationComponent } from 'src/app/save-confirmation/save-confirmation.component';

@Component({
  selector: 'app-component-data-entry',
  templateUrl: './component-data-entry.component.html',
  styleUrls: ['./component-data-entry.component.scss']
})
export class ComponentDataEntryComponent {
@Input()item:any
@Output() dataEvent = new EventEmitter<any>();
@Output() respData = new EventEmitter<any>();
@Output() compDataRemarks = new EventEmitter<any>();


  gdbValue:boolean = false;
  isDataSaved:boolean = false
  instructions: string
  addressComponent: boolean = false
  educationComponent: boolean = false
  employmentComponent: boolean = false
  identityComponent: boolean = false
  gapvfnComponent: boolean = false
  cvanalysisComponent: boolean = false
  uanComponent: boolean = false
  twentysixasComponent: boolean = false
  creditcheckComponent: boolean = false
  credittransComponent: boolean = false
  epfoComponent: boolean = false
  crconlineComponent: boolean = false
  socialmediaComponent: boolean = false
  globalmediasearchComponent: boolean = false
  facisl3Component: boolean = false
  ofacComponent: boolean = false
  drugtestComponent: boolean = false
  voterIdComponent: boolean = false
  panComponent: boolean = false
  passportComponent: boolean = false
  directorshipcheckComponent: boolean = false
  gstcheckComponent: boolean = false
  dlComponent: boolean = false
  adharComponent: boolean = false
  bankStatementComponent: boolean = false
  globaldatabaseComponent: boolean = false
  statusInDb: string
  inputqcComments: string
  componentDisplayName: string
  mandatoryField: boolean
  displayedCandidateDocName: any
  fileUploadRequired: boolean
  isFileUploaded = false;
  

  caseId: any
  case_id: any
  gapDataForTable: any
  profile: any
  package: any
  alacart:any
  check_id: any
  component_id : any
  components: any[] = []
  navItems: any[] = []
  componentFields: any = []
  componentDataEntryForm = new FormGroup({
    fileName: new FormControl(''),
    componentFile: new FormControl('')
  })
  candidateDocuments: any[]
  candidateDocBlob: any
  showCandidateDocsDialog: boolean = false

  compId:any;
  compSerialNo:any;
  componentName:any;

  constructor(
    private caseUploadService: CaseUploadService,
    private clientContractProfileService: ClientContractProfileService,
    private clientContractPackageService: ClientContractPackageService,
    private activatedRoute: ActivatedRoute,
    private personalDetailsDataService: PersonalDetailsDataService,
    private componentService: ComponentService,
    private componentDataService: ComponentDataService,
    private snackBar: MatSnackBar,
    private dialog:MatDialog
  ) { }

  // ngOnInit(): void {
  //   if (this.item.children.length) {
  //     console.log('component name == ', this.item.children[0].componentName);
  //     this.compId = this.item.children[0].component_id; 
  //     this.compSerialNo = this.item.children[0].component_serialNumber;
  //     this.componentName = this.item.children[0].componentName
  //   } else {
  //     this.compId = this.item.component_id;
  //     this.compSerialNo = this.item.component_serialNumber;
  //     this.componentName = this.item.componentName
  //   }
  //   this.getComponentDetails()
  //   this.getComponentFields()
  //   this.getTableDataForGap()
  // }

  ngAfterViewInit(){
    if (this.item.children.length) {
      this.compId = this.item.children[0].component_id; 
      this.compSerialNo = this.item.children[0].component_serialNumber;
      this.componentName = this.item.children[0].componentName
    } else {
      this.compId = this.item.component_id;
      this.compSerialNo = this.item.component_serialNumber;
      this.componentName = this.item.componentName
    }
    this.getComponentDetails()
    this.getComponentFields()
    this.getTableDataForGap()
  }


  async getComponentDetails() {
    await this.getCaseDetails()
    // if (this.profile != null) {
    //   this.components = <any[]>await this.getProfileDetails()
    // } else if (this.package != null) {
    //   this.components = <any[]>await this.getPackageDetails()
    // }  else if (this.alacart != null) {
    //   this.components = <any[]>await this.getalacartDetails()
    // }

    // await this.setComponentMenuItems()
    await this.readComponentDetails()
    this.readCandidateDocs()
  }

  refreshButton(){
    if (this.item.children.length) {
      this.compId = this.item.children[0].component_id; 
      this.compSerialNo = this.item.children[0].component_serialNumber;
      this.componentName = this.item.children[0].componentName
    } else {
      this.compId = this.item.component_id;
      this.compSerialNo = this.item.component_serialNumber;
      this.componentName = this.item.componentName
    }
    this.getComponentDetails()
    this.getComponentFields()
    this.getTableDataForGap()
  }
 
  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }
  
  async getComponentFields() {
    // if (this.item.children.length) {
    //   this.compId = this.item.children[0].component_id; 
    //   this.compSerialNo = this.item.children[0].component_serialNumber;
    // } else {
    //   this.compId = this.item.component_id;
    //   this.compSerialNo = this.item.component_serialNumber;
    // }

    this.componentService.findAComponentForCde(this.compId, this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.compSerialNo).subscribe(
      response => {
        this.fileUploadRequired = response.fileUploadRequired
        this.componentFields = response.componentFields;
        this.mandatoryField = this.componentFields.mandatory === "MANDATORY" ? true : false
        this.componentDisplayName = response.displayName
        if (response.name == 'employment' || response.name == 'empbasic' || response.name == 'empadvance') {
          this.employmentComponent = true
        } else if (response.name == 'address' || response.name == 'addressonline' || response.name == 'addresstelephone' || response.name == 'addresscomprehensive') {
          this.addressComponent = true
        } else if (response.name == 'educationcomprehensive' || response.name == 'educationadvanced' || response.name == 'education') {
          this.educationComponent = true
        } else if (response.name == 'globaldatabase') {
          this.globaldatabaseComponent = true

        } else if (response.name == 'reference' || response.name == 'refbasic') {

        } else if (response.name == 'criminalrecord') {

        } else if (response.name == 'courtrecord') {

        } else if (response.name == 'identity') {
          this.identityComponent = true
        } else if (response.name == 'gapvfn') {
          this.gapvfnComponent = true
        } else if (response.name == 'drugtestfive' || response.name == 'drugtestsix' || response.name == 'drugtestseven' || response.name == 'drugtesteight' || response.name == 'drugtestnine' || response.name == 'drugtestten') {
          this.drugtestComponent = true
        } else if (response.name == 'cvanalysis') {
          this.cvanalysisComponent = true
        } else if (response.name == 'creditcheck') {
          this.creditcheckComponent = true
        } else if (response.name == 'uan') {
          this.uanComponent = true
        } else if (response.name == 'twentysixas') {
          this.twentysixasComponent = true
        } else if (response.name == 'credittrans') {
          this.credittransComponent = true
        } else if (response.name == 'epfo') {
          this.epfoComponent = true
        } else if (response.name == 'crconline') {
          this.crconlineComponent = true
        } else if (response.name == 'socialmedia') {
          this.socialmediaComponent = true
        } else if (response.name == 'ofac') {
          this.ofacComponent = true
        } else if (response.name == 'globalmediasearch') {
          this.globalmediasearchComponent = true
        } else if (response.name == 'facisl3') {
          this.facisl3Component = true
        } else if (response.name == 'passport') {
          this.passportComponent = true
        } else if (response.name == 'directorshipcheck') {
          this.directorshipcheckComponent = true
        } else if (response.name == 'gstcheck') {
          this.gstcheckComponent = true
        }
        this.addFormControls();
      },
      error => {
        console.log('error === ', error);

        this.showError("Error Configuring Personal Details");
      }
    )
  }
  addFormControls() {
    this.componentFields.forEach(item => {
      this.componentDataEntryForm.addControl(item.name, new FormControl(''));
      if (item.mandatory === "MANDATORY") {
        this.componentDataEntryForm.get(item.name).setValidators(Validators.required);
      }
    })

  }
  getFieldSize(componentField: any) {
    return componentField.size;
  }
  getValues(name) {
    for (let field of this.componentFields) {
      if (field.name === name) {
        let values = field.values;
        if (values !== "") {
          return values.split(",");
        }
      }
    }
    return null;
  }
  readComponentDetails() {
    let promise = new Promise((resolve, reject) => {
      // for (let i = 0; i < this.components.length; i++) {
      //   let item = this.components[i]
      //   console.log('instruction === ', item)
        
      //   if (this.compId == item.component) {
          
      //     this.instructions = item.details
      //     break
      //   }
      // }
      if (this.componentName === 'globaldatabase') {
        this.personalDetailsDataService.readForCde(this.case_id, this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          response => {
            if (response) {
              this.gdbValue = true;
              this.componentFields.forEach(item => {
                if (item.type != 'DATE') {
                  if (item.name === "searchname") {
                    this.componentDataEntryForm.get(item.name)?.setValue(response.candidatename);
                  }
                   else {
                    this.componentDataEntryForm.get(item.name)?.setValue(response[item.name]);
                    
                  }
                  
                } else {
                  let dateValue = new Date(response.dateofbirth);
                  let dd = dateValue.getDate();
                  let mm = dateValue.getMonth() + 1;
                  let yyyy = dateValue.getFullYear().toString();
                  let stringdd = '';
                  let stringmm = ''
    
                  if (dd < 10) {
                    stringdd = '0' + dd;
                  } else {
                    stringdd = dd.toString();
                  }
                  if (mm < 10) {
                    stringmm = '0' + mm;
                  } else {
                    stringmm = mm.toString();
                  }
                  this.componentDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
                }
              })
            }
    
          },
          error => {
            this.showError(error.error.message);
          }
        )
      }
      this.componentDataService.findOneForCde(this.componentName, this.case_id, this.compSerialNo).subscribe(
        response => {
          if (response) {
            console.log('hello ');
            
            this.respData.emit(!!response)
            this.check_id = response._id;
            this.case_id = response.case
            this.componentFields.forEach(item => {
              if (item.type != 'DATE') {
                this.componentDataEntryForm.get(item.name).setValue(response[item.name]);
              } else {
                let dateValue = new Date(response[item.name]);
                let dd = dateValue.getDate();
                let mm = dateValue.getMonth() + 1;
                let yyyy = dateValue.getFullYear().toString();
                let stringdd = '';
                let stringmm = ''

                if (dd < 10) {
                  stringdd = '0' + dd;
                } else {
                  stringdd = dd.toString();
                }
                if (mm < 10) {
                  stringmm = '0' + mm;
                } else {
                  stringmm = mm.toString();
                }
                this.componentDataEntryForm.get(item.name).setValue(yyyy + '-' + stringmm + '-' + stringdd);
              }
            })
            if (response.status != null && response.status == 'CDE-REJECTED') {
              this.inputqcComments = response.inputqcComments
              this.statusInDb = response.status
              this.compDataRemarks.emit(true)
            } else {
              this.compDataRemarks.emit(false)
            }
          } else {
            this.respData.emit(!!response)
          }
          resolve(true)
        },
        error => {
          this.showError(error.error.message);
          resolve(false)
        }
      )
    })
    return promise
  }
  readCandidateDocs() {
    this.candidateDocuments = []
    this.componentDataService.readFileNamesForCde(this.componentName, this.caseId, this.check_id).subscribe(
      response => {
        this.candidateDocuments = response;
      },
      error => {
        console.log(error);
      }
    )
  }

  saveConfirmation(){
    const confirmDialog = this.dialog.open(SaveConfirmationComponent,{
      width:'400px',data:{message:`Are you sure that you want to submit this form `}
    });
    confirmDialog.afterClosed().subscribe(result=>{
      if(result.event=='confirmed'){
        this.saveButtonClicked();
      }
    })  
  }




  saveButtonClicked() {
    if (this.check_id == null) {
      let componentData = this.componentDataEntryForm.getRawValue()
      console.log('save click if block this.check_id === ', this.check_id);
      // this.dataEvent.emit(this.item)
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.component = this.compId
      componentData.serialNumber = this.compSerialNo;
      this.componentDataService.findOneForCde(this.componentName, this.case_id, this.compSerialNo).subscribe(
        responseFromRead => {
          if (responseFromRead == null) {
            this.componentDataService.createForCde(this.componentName, componentData).subscribe(
              response => {
                this.check_id = response._id
                this.dataEvent.emit(this.item)
                this.showMessage("Data Saved")
              
              },
              error => {
                this.showError("Error creating the check")
              }
            )
          } else {
            this.showError("Details Already Saved")
          }
        },
        error => {
          this.showError("Error reading the Details")
        }
      )
    } else {
      let componentData = this.componentDataEntryForm.getRawValue()
      console.log('componentData   === ', componentData);
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.case_id = this.case_id
      componentData._id = this.check_id
      componentData.component = this.compId
      componentData.serialNumber = this.compSerialNo;
      this.componentDataService.updateForCde(this.componentName, componentData).subscribe(
        response => {
          this.check_id = response._id
          this.dataEvent.emit(this.item)
          this.showMessage("Data Saved")
        },
        error => {
          this.showError("Error Updating the check")
        }
      )
    }
    this.isDataSaved = true

  }
  downloadCandidateDoc(fileName) {
    let componentDetails = ({

    })
    componentDetails["caseId"] = this.caseId;
    componentDetails["_id"] = this.check_id;
    this.componentDataService.downloadFileForCde(this.componentName, componentDetails, fileName).subscribe(
      (response: HttpResponse<Blob>) => {
        // console.log("dasdedesd",response.body);
        
        this.candidateDocBlob = response.body;
        this.showCandidateDocsDialog = true;
      },
      error => {
        this.showError(error.error.message);
      }
    )
  }

  onFileSelected(event:any){
    const files = event.target.files;
    if(files.length > 0){
      const fileName = files[0].name;
      this.componentDataEntryForm.get('fileName').setValue(fileName);
    }
  }
  uploadFile() {
    if (this.check_id == null) {
      console.log("if.............................")
      let componentData = this.componentDataEntryForm.getRawValue()
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.case_id = this.case_id;
      componentData.caseId = this.caseId;
      componentData.case = this.case_id;
      componentData._id = this.check_id
      componentData.component = this.compId
      componentData.serialNumber = this.compSerialNo
      console.log("componentData :",componentData)
      this.componentDataService.createForCde(this.componentName, componentData).subscribe(
        response => {
          console.log("response :",response)
          this.check_id = response._id
          let componentData = this.componentDataEntryForm.getRawValue();
          componentData.case_id = this.case_id;
          componentData.caseId = this.caseId;
          componentData.case = this.case_id;
          componentData._id = this.check_id
          this.componentDataService.uploadFileForCde(this.componentName, componentData, this.componentDataEntryForm.get('componentFile').value.files[0]).subscribe(
            response => {
              this.showMessage("File Uploaded");
              this.readCandidateDocs()
            },
            error => {
              this.showError("Error uploading the file");
            }
          )
        },
        error => {
          console.log("Create error ", error)
          this.showError("Error creating the check")
        }
      )
    } else {
      console.log("else.............................")
      let componentData = this.componentDataEntryForm.getRawValue()
      componentData.status = "CDE-COMPLETED"
      componentData.case = this.case_id
      componentData.case_id = this.case_id
      componentData._id = this.check_id
      componentData.case_id = this.case_id;
      componentData.caseId = this.caseId;
      componentData.case = this.case_id;
      componentData._id = this.check_id
      componentData.component = this.compId
      componentData.serialNumber = this.compSerialNo
      console.log("@@@@@@@@@@@@@@@@@@@@@",componentData);
      
      this.componentDataService.updateForCde(this.componentName, componentData).subscribe(
        response => {
          //          this.check_id = response._id
          let componentData = this.componentDataEntryForm.getRawValue();
          componentData.case_id = this.case_id;
          componentData.caseId = this.caseId;
          componentData.case = this.case_id;
          componentData._id = this.check_id
          this.componentDataService.uploadFileForCde(this.componentName, componentData, this.componentDataEntryForm.get('componentFile').value.files[0]).subscribe(
            response => {
              this.showMessage("File Uploaded");
              this.readCandidateDocs()
            },
            error => {
              this.showError("Error uploading the file");
            }
          )
        },
        error => {
          console.log("update error ", error)
          this.showError("Error updating the check")
        }
      )
    }
    const formData = new FormData();
    const files = this.componentDataEntryForm.get('componentFile').value.files;
    if (files.length > 0) {
        const file = files[0];
        const fileName = encodeURIComponent(file.name); 
        formData.append('file', file, fileName);
    }

    this.isFileUploaded = true;
    }

  getTableDataForGap() {
    // console.log("Component in query map is ", this.activatedRoute.snapshot.queryParamMap.get('component_id'))
    this.componentService.findAComponentForCde(this.compId, this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.compSerialNo).subscribe(
      response => {
        if (response.name === "gapvfn") {
          this.componentService.getGapDataForTable(this.case_id).subscribe(
            gapResponse => {
              this.gapDataForTable = gapResponse
            },
            gapError => {
              this.gapDataForTable = []
            }
          )
        }
      }
    )
  }
  deleteCandidateDoc(fileName) {
    let componentDetails = ({

    })
    componentDetails["caseId"] = this.caseId;
    componentDetails["_id"] = this.check_id;
    this.componentDataService.deleteFileForCde(this.componentName, componentDetails, fileName).subscribe(
      response => {
        this.showMessage("File Deleted")
      },
      error => {
        this.showError("Error Deleting the file")
      }
    )
  }
  deleteButtonClicked() {
    this.componentDataService.deleteForCde(this.componentName, this.case_id, this.check_id).subscribe(
      response => {
        this.componentDataService.deleteAllFilesForCde(this.componentName, this.caseId, this.check_id).subscribe(
          response => {
            this.showMessage("Deleted the Details")
            this.readCandidateDocs()
          },
          error => {
            this.showError("Error Deleting files")
          }
        )

      },
      error => {
        this.showError("Error deleting the Details")
      }
    )
  }
  closeCandidateDocsDialog() {
    this.showCandidateDocsDialog = false
  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Info', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
}
function output(): (target: ComponentDataEntryComponent, propertyKey: "msg") => void {
  throw new Error('Function not implemented.');
}

